import { api } from "../api";

const expensesFindAllByActivated = async (
    token: string,
    customerId: number,
    vehicleId: number,
    status: string,
    page: number,
    size: number,
) => {
    return api.get(`/expenses/${customerId}/${vehicleId}/${status}`, {
        params: {
            page,
            size,
        },
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default expensesFindAllByActivated;
